import { render } from "./StatisticsNav.vue?vue&type=template&id=47e37d1e&ts=true"
import script from "./StatisticsNav.vue?vue&type=script&lang=ts"
export * from "./StatisticsNav.vue?vue&type=script&lang=ts"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__